module.exports = __webpack_public_path__ + "static/img/logo.861ffd9e.png";